<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>Timekeep Group</h1>
      <v-row>
        <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
          <v-text-field
            label="Code"
            :class="classPadding"
            v-model="tksGroup.groupCode"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
          <v-text-field
            label="Description"
            :class="classPadding"
            v-model="tksGroup.groupDescription"
          ></v-text-field>
        </v-col>
        <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
          <v-text-field
            label="Payroll Group"
            :class="classPadding"
            v-model="tksGroup.locName"
            readonly
          >
            <template slot="append">
              <v-icon @click.stop="searchPayLoc">mdi-magnify</v-icon>
              <!-- <span class="required">*</span> -->
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
          <v-btn
            color="success"
            :loading="isSaving"
            :class="classPadding"
            @click.stop="save"
            v-if="userAccess.add >= 1"
            >Save</v-btn
          >
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <list :key="componentKey">
        <template slot="actions" slot-scope="{ item }">
          <v-btn @click.stop="edit(item)" text icon v-if="userAccess.edit >= 1">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
            v-if="userAccess.delete >= 1"
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </list>
      <!-- <router-view /> -->
    </v-container>
    <v-dialog v-model="editDialog" width="700" persistent>
      <v-card>
        <v-card-title>
          <span>Edit</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
              <v-text-field
                label="Code"
                :class="classPadding"
                v-model="editTksGroup.groupCode"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
              <v-text-field
                label="Description"
                :class="classPadding"
                v-model="editTksGroup.groupDescription"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="4" md="4" class="pb-0 mb-0">
              <v-text-field
                label="Payroll Group"
                :class="classPadding"
                v-model="editTksGroup.locName"
                readonly
              >
                <template slot="append">
                  <v-icon @click.stop="searchPayLoc">mdi-magnify</v-icon>
                  <!-- <span class="required">*</span> -->
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.stop="editDialog = false">close</v-btn>
          <v-btn
            text
            @click.stop="update"
            color="success"
            :loading="isUpdating"
            v-if="userAccess.update >= 1"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="payLocDialog" width="700">
      <v-card>
        <v-card-title>
          <span class="headline">Payroll Location</span>
        </v-card-title>
        <v-card-text>
          <payroll-location
            :show-dense="false"
            :show-title="false"
            :headers="payLocHeaders"
          >
            <template slot="actions" slot-scope="{ item }">
              <v-btn @click.stop="selectPayLoc(item)" text outlined
                >Select</v-btn
              >
            </template>
          </payroll-location>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.stop="payLocDialog = false" text
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import List from "./List";
import PayrollLocation from "../payroll-location/Pagination";
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/tksGroup";
export default {
  metaInfo: {
    title: "Timekeep Group",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`,
  },
  mixins: [userAccessMixin],
  components: {
    List,
    PayrollLocation,
  },
  data: () => ({
    classPadding: "my-0 py-0",
    componentKey: 0,
    tksGroup: {},
    isSaving: false,
    editTksGroup: {},
    editDialog: false,
    isUpdating: false,
    payLocDialog: false,
    payLocHeaders: [
      {
        text: "",
        align: "left",
        sortable: false,
        value: "action",
      },
      {
        text: "Loc Id",
        align: "left",
        //sortable: false,
        value: "locId",
      },
      {
        text: "Location Name",
        align: "left",
        //sortable: false,
        value: "locName",
      },
    ],
  }),
  methods: {
    save() {
      this.$axios
        .post(`${API_ENDPOINT}`, this.tksGroup)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    update() {
      this.isUpdating = true;
      this.$axios
        .put(`${API_ENDPOINT}`, this.editTksGroup)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isUpdating = false;
        });
    },
    reset() {
      this.tksGroup = {};
      this.forceRerender();
      this.editDialog = false;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    edit(item) {
      this.editTksGroup = Object.assign({}, item);
      this.editTksGroup.payrollGroup = item.locId;
      this.editDialog = true;
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete",
      }).then((res) => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.groupCode}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    searchPayLoc() {
      this.payLocDialog = true;
    },
    selectPayLoc(item) {
      if (this.editDialog) {
        this.editTksGroup.locName = item.locName;
        this.editTksGroup.payrollGroup = item.locId;
        this.payLocDialog = false;
      } else {
        this.tksGroup.locName = item.locName;
        this.tksGroup.payrollGroup = item.locId;
        this.payLocDialog = false;
      }
    },
  },
  created() {
    this.getUserAccessRights("TKSGRPSTUP");
  },
};
</script>
